import PublicLayout from "@/components/PublicLayout";
import { AlertTriangle } from "lucide-react";
import { useSEO } from "@/lib/useSEO";

export default function DisclaimerPage() {
  useSEO({
    title: "Disclaimer — InsureGenie India | Educational Guidance Only",
    description: "InsureGenie provides educational insurance information for Indian users and is not a licensed insurance advisor. Always consult a qualified professional.",
  });
  return (
    <PublicLayout eyebrow="Important" title="Disclaimer.">
      <div className="not-prose flex items-start gap-3 bg-accent/10 border border-accent/30 rounded-2xl p-5 my-6">
        <AlertTriangle className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" />
        <div className="text-sm leading-relaxed">
          <strong className="text-foreground">InsureGenie is an educational AI assistant — not a licensed advisor.</strong>
          {" "}Always consult qualified professionals before purchasing insurance or making financial decisions.
        </div>
      </div>

      <h2>What InsureGenie does</h2>
      <p>
        InsureGenie provides educational information about insurance concepts, products, exclusions, waiting periods,
        sub-limits, claim processes, and tax benefits. Information is drawn from publicly available policy brochures,
        IRDAI guidelines, and other open sources, and is interpreted by an AI model (Claude Sonnet 4.5).
      </p>

      <h2>What InsureGenie does NOT do</h2>
      <ul>
        <li>It does <strong>not</strong> sell, broker, or recommend the purchase of any specific insurance product.</li>
        <li>It does <strong>not</strong> provide regulated insurance advice as defined by the Insurance Regulatory and Development Authority of India (IRDAI).</li>
        <li>It does <strong>not</strong> provide tax advice as defined by the Income Tax Act of India.</li>
        <li>It does <strong>not</strong> provide investment or financial planning advice as defined by SEBI.</li>
        <li>It does <strong>not</strong> provide legal advice.</li>
      </ul>

      <h2>Accuracy disclaimer</h2>
      <p>
        AI-generated content can be inaccurate or out of date. Insurance policy terms, premiums, network hospitals,
        exclusions, and tax rules change frequently. Always verify material facts with:
      </p>
      <ul>
        <li>The official insurer (policy brochure, customer service).</li>
        <li>IRDAI&apos;s official portal: <a href="https://www.irdai.gov.in" target="_blank" rel="noreferrer">www.irdai.gov.in</a>.</li>
        <li>A licensed insurance broker, IRDAI-registered agent, or financial advisor.</li>
        <li>A qualified Chartered Accountant or tax professional for tax matters.</li>
      </ul>

      <h2>No fiduciary relationship</h2>
      <p>
        Using InsureGenie does not create any fiduciary, advisory, broker-client, or attorney-client relationship
        between you and InsureGenie or its operators.
      </p>

      <h2>External links</h2>
      <p>
        InsureGenie may reference third-party websites and resources for context. We are not responsible for the
        accuracy, availability, or content of any external resource.
      </p>

      <h2>Your responsibility</h2>
      <p>
        You are solely responsible for the financial decisions you make. By using InsureGenie, you acknowledge that
        you understand the educational nature of the Service and agree not to treat its output as professional advice.
      </p>
    </PublicLayout>
  );
}
